import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { TicketCreateBody } from './create';

export type TicketUpdateData = {
  success: boolean;
};

export type TicketUpdateResponse = TicketUpdateData;

export type TicketUpdateBody = Partial<TicketCreateBody>

export interface TicketUpdatePayload {
  id: string;
  body: TicketUpdateBody
}

export const ticketUpdate = (payload: TicketUpdatePayload): Action<TicketUpdatePayload> => ({
  type: actions.ticketUpdateTrigger.toString(),
  payload,
});

export const ticketUpdateClear = (): Action => ({
  type: actions.ticketUpdateClear.toString(),
});

export const ticketUpdateErrorClear = (): Action => ({
  type: actions.ticketUpdateErrorReset.toString(),
});

export function* ticketUpdateRequestSaga({ payload }: Action<TicketUpdatePayload>) {
  yield put({
    type: actions.ticketUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.ticketUpdateError.toString(),
      payload: {
        message: 'TicketUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/tickets/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TicketUpdateData, TicketUpdateResponse>(
    response,
    actions.ticketUpdateSuccess.toString(),
    actions.ticketUpdateError.toString(),
    false,
    (ticketUpdateData) => ticketUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.ticketUpdateTrigger.toString(),
    defaultProcessingSaga(
      ticketUpdateRequestSaga,
      {
        error: actions.ticketUpdateError.toString(),
        locationCancel: actions.ticketUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.ticketUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.ticketUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.ticketUpdateErrorReset.toString(),
    });
  });
}
